import React from "react";
import {
  IonItem,
  IonAvatar,
  IonImg,
  IonLabel,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonContent,
  IonChip,
  IonButton,
} from "@ionic/react";

import Section from "./Section";

export default function ProductDetails({
  title = "Details",
  productDetails = {},
  description = {},
  shippingAndReturns = {},
}) {
  return (
    <Section title={title} isOpenDefault={false}>
      <p className="fb-section-content-p mb-1">
        <div dangerouslySetInnerHTML={{ __html: description.content }}></div>
        <p className="fb-section-content-cta">{description.moreInfo}</p>
      </p>

      {productDetails.options.map((option) =>
        option.isLink ? (
          <IonRow className="ion-align-items-center">
            <p className="fb-section-content-p m-0">
              {option.label}&nbsp;·&nbsp;
            </p>

            <p
              className="fb-section-content-p m-0 fb-section-content-cta "
              dangerouslySetInnerHTML={{ __html: option.value }}
            ></p>
          </IonRow>
        ) : (
          <React.Fragment>
            <p className="fb-section-content-p" style={{ marginTop: "1rem" }}>
              {option.label}
            </p>
            <p
              className="fb-section-content-p-secondary m-0"
              dangerouslySetInnerHTML={{ __html: option.value }}
            ></p>
          </React.Fragment>
        )
      )}

      {shippingAndReturns.options.map((option) =>
        option.isLink ? (
          <IonRow>
            <p className="fb-section-content-p m-0">
              {option.label}&nbsp;·&nbsp;
            </p>

            <p className="fb-section-content-p-sm-secondary m-0">
              {option.value}
            </p>
          </IonRow>
        ) : (
          <>
            <p className="fb-section-content-p" style={{ marginTop: "1rem" }}>
              {option.label}
            </p>

            <IonRow style={{ marginTop: "2px" }}>
              <p className="fb-section-content-p-secondary m-0">
                {option.value}
              </p>
              {option.link && (
                <a
                  className="fb-section-content-cta"
                  style={{ marginLeft: "4px" }}
                >
                  {option.link}
                </a>
              )}
            </IonRow>
          </>
        )
      )}
    </Section>
  );
}
